import { useState } from "react";
import "./Accordion.css";
import { FaRegQuestionCircle } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";



export default function Accordion({ faqs, defaultOpenIndex = 0  }) {
  const [openIndex, setOpenIndex] = useState(defaultOpenIndex);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="accordion-section">
      {faqs.map((item, index) => (
        <div
          key={index}
          className={`accordion-item ${openIndex === index ? "active" : ""}`}
        >
          <div className="accordion-header" onClick={() => toggle(index)}>
            <FaRegQuestionCircle className="accordion-icon" />
            <h3>{item.question}</h3>
            <div className="accordion-toggle-icon">
              {openIndex === index ? <IoIosArrowUp /> : <IoIosArrowDown />}
            </div>
          </div>
          {openIndex === index && (
            <div className="accordion-content">
              <p>{item.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
